import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesGrid from './components/ServicesGrid';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';

const ServicesPage = () => {
  useEffect(() => {
    document.title = '事業内容 - 岡山市北区の訪問介護サービス｜ヘルパーステーションおかやま';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '岡山市北区で提供する訪問介護サービスの詳細。身体介護、生活援助、通院介助など、資格保有ヘルパーによる質の高いケアをご提供します。介護保険適用で安心の料金体系。');
    }

    // Add Service Schema
    const serviceSchema = document.createElement('script');
    serviceSchema.type = 'application/ld+json';
    serviceSchema.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "訪問介護サービス",
      "provider": {
        "@type": "LocalBusiness",
        "name": "ヘルパーステーションおかやま",
        "telephone": "+81-86-012-3456",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "岡山市北区",
          "addressRegion": "岡山県",
          "addressCountry": "JP"
        }
      },
      "areaServed": {
        "@type": "City",
        "name": "岡山市北区"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "訪問介護サービス",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "身体介護",
              "description": "食事介助、入浴介助、排泄介助、更衣介助、体位変換など"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "生活援助",
              "description": "掃除、洗濯、買い物代行、調理、薬の受け取りなど"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "通院介助",
              "description": "病院への付き添い、受診手続きのサポート"
            }
          }
        ]
      }
    });
    document.head.appendChild(serviceSchema);

    return () => {
      if (serviceSchema.parentNode) {
        serviceSchema.parentNode.removeChild(serviceSchema);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ServicesHero />
        <ServicesGrid />
        <PricingSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;